import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { handleInputChange, toggleRevealPassword } from '../../utilities/form_utilities';
import { Link, Button } from '../../ui_kit';

function SignUpForm({ signUpUser, handleSignInFormChange, errorMessages }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [revealPassword, setRevealPassword] = useState(false);
  const [revealConfirmPassword, setRevealConfirmPassword] = useState(false);

  function handleSignUpClicked(e) {
    e.preventDefault();

    signUpUser({ name, email, password, confirmPassword });
  }

  return (
    <div className="component-sign-up-form">
      <div className="standard-form">
        <h2>Sign Up</h2>
        <p className="form-info">Create your account.</p>

        <label className="name" htmlFor="name">
          <p>Name</p>
          <div className="input-container">
            <input
              id="name"
              type="text"
              value={name}
              tabIndex={0}
              onChange={(e) => {
                handleInputChange(setName, e);
              }}
              className={errorMessages.name ? 'errors' : ''}
            />
          </div>
          {errorMessages.name && <p className="input-errors">Name {errorMessages.name}.</p>}
        </label>

        <label className="email" htmlFor="email">
          <p>Email</p>
          <div className="input-container">
            <input
              id="email"
              type="text"
              value={email}
              tabIndex={0}
              onChange={(e) => {
                handleInputChange(setEmail, e);
              }}
              className={errorMessages.email ? 'errors' : ''}
            />
          </div>
          {errorMessages.email && <p className="input-errors">Email {errorMessages.email}.</p>}
        </label>

        <label className="password" htmlFor="password">
          <div className="password-label">
            <p>Password (minimum 6 characters)</p>
          </div>
          <div className="input-container password">
            <input
              id="password"
              type={revealPassword ? 'text' : 'password'}
              value={password}
              tabIndex={0}
              onChange={(e) => {
                handleInputChange(setPassword, e);
              }}
              className={errorMessages.password ? 'errors' : ''}
            />
            <div
              role="button"
              tabIndex={-1}
              className="eye-selector"
              onClick={() => {
                toggleRevealPassword(setRevealPassword, revealPassword, 'password');
              }}
              onKeyDown={() => {
                toggleRevealPassword(setRevealPassword, revealPassword, 'password');
              }}
            >
              <span
                id="password-eye-closed"
                className="icon iconify password-eye closed hide"
                data-icon="mdi-light:eye-off"
                data-inline="true"
                data-interception="off"
              />
              <span
                id="password-eye-open"
                className="icon iconify password-eye open show"
                data-icon="mdi-light:eye"
                data-inline="true"
                data-interception="off"
              />
            </div>
          </div>
          {errorMessages.password && <p className="input-errors">Password {errorMessages.password}.</p>}
        </label>

        <label className="password" htmlFor="confirm-password">
          <div className="password-label">
            <p>Confirm Password</p>
          </div>
          <div className="input-container password">
            <input
              id="password"
              type={revealConfirmPassword ? 'text' : 'password'}
              value={confirmPassword}
              tabIndex={0}
              onChange={(e) => {
                handleInputChange(setConfirmPassword, e);
              }}
              className={errorMessages.password_confirmation ? 'errors' : ''}
            />
            <div
              role="button"
              tabIndex={-1}
              className="eye-selector"
              onClick={() => {
                toggleRevealPassword(setRevealConfirmPassword, revealConfirmPassword, 'confirm-password');
              }}
              onKeyDown={() => {
                toggleRevealPassword(setRevealConfirmPassword, revealConfirmPassword, 'confirm-password');
              }}
            >
              <span
                id="confirm-password-eye-closed"
                className="icon iconify password-eye closed hide"
                data-icon="mdi-light:eye-off"
                data-inline="true"
                data-interception="off"
              />
              <span
                id="confirm-password-eye-open"
                className="icon iconify password-eye open show"
                data-icon="mdi-light:eye"
                data-inline="true"
                data-interception="off"
              />
            </div>
          </div>
          {errorMessages.password_confirmation && (
            <p className="input-errors">Password Confirmation {errorMessages.password_confirmation}.</p>
          )}
        </label>

        <Button
          className="submit-button small-heading dark"
          onClick={handleSignUpClicked}
          onKeyDown={(e) => {
            if (e.keyCode === 13) handleSignUpClicked(e);
          }}
          title="Sign Up"
          tabIndex={0}
        />

        <div className="sign-in-container">
          <p>
            Already have an account?{' '}
            <span>
              <Link className="sign-up-link" onClick={handleSignInFormChange} tabIndex={0}>
                Sign In
              </Link>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

SignUpForm.propTypes = {
  signUpUser: PropTypes.func.isRequired,
  handleSignInFormChange: PropTypes.func.isRequired,
  errorMessages: PropTypes.object.isRequired,
};

export default SignUpForm;
